import React from "react"
import { Hyperlink } from "../themed-html-components"
import { ENVIRONMENT } from "../../constants"

/** The loading spinner to display whilst a particular filter field is having its values loaded */
function LoginViaIdServer() {
  return ENVIRONMENT.getLoginPath() ? (
    <Hyperlink href={ENVIRONMENT.getLoginPath()} text="Login via Identity Server" />
  ) : null
}

export default LoginViaIdServer



// WEBPACK FOOTER //
// ./src/components/auth/LoginViaIdServer.jsx